import { gql } from '@apollo/client'

export const PERSISTENT_ALERT_BANNER_QUERY = gql`
  query PersistentAlertBanner($appPageId: String) {
    root {
      persistentAlertBannerViewer(appPageId: $appPageId) @ignoreExceptions {
        type
        text
        icon {
          type
        }
        link {
          url
          label
        }
      }
    }
  }
`
